<template>
  <div class="ma-3">
    <div class="title mb-3">
      Freelances Prices lists
    </div>

    <div
      layout="column"
      layout-align="center center"
    >
      <div
        layout="column"
      >
        <div>
          <v-btn
            flat
            class="mt-3"
            :to="{name: 'admin-fees-freelances-priceslists-edit', params: {id: 'new'}}"
          >
            <v-icon
              left
              color="primary"
            >
              mdi-plus-box
            </v-icon>
            Define a new period for the freelances prices list
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="fees"
          style="max-width: 1280px"
          :pagination.sync="pagination"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>
              <router-link :to="{name: 'admin-fees-freelances-priceslists-edit', params: {id: item.id}}">
                <v-icon
                  v-if="current && current.id == item.id"
                  small
                  color="primary"
                  title="Current period"
                >
                  mdi-star
                </v-icon>&nbsp;{{ formatDate(item.effective_date) }}
              </router-link>
            </td>
            <td>{{ moneyFormat(item.animator_amount) }}</td>
            <td>{{ moneyFormat(item.animator_independent_amount) }}</td>
            <td>{{ moneyFormat(item.instructor_amount) }}</td>
            <td>{{ moneyFormat(item.instructor_independent_amount) }}</td>
            <td>{{ moneyFormat(item.expert_amount) }}</td>
            <td>{{ moneyFormat(item.expert_independent_amount) }}</td>
            <td layout="row">
              <v-btn
                class="mx-0"
                icon
                :to="{name: 'admin-fees-freelances-priceslists-edit', params: {id: item.id}}"
                :disabled="!isAppCoord(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <delete-button
                :label="`the period ${formatDate(item.effective_date)}`"
                :disabled="!isAppCoord(item) || item.effective_date <= today"
                @confirm="deleteImpl(item)"
              />
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
    import Params from '@/api/params'
    import DeleteButton from "@/components/shared/DeleteButton.vue"
    import GlobalMixin from "@/mixins/global"
    import DatesMixin from "@/mixins/date"
    import moment from "moment"

    export default {
        components: {DeleteButton},
        mixins: [GlobalMixin, DatesMixin],
        data () {
          return {
            pagination: {
                rowsPerPage: 10
            },
            headers: [
                { text: 'Effective date', value: 'effective_date', sortable: false },
                {text: 'Animator non-independent', value: 'animator_amount', sortable: false},
                {text: 'Animator independent', value: 'animator_independent_amount', sortable: false},
                {text: 'Instructor non-independent', value: 'instructor_amount', sortable: false},
                {text: 'Instructor independent', value: 'instructor_independent_amount', sortable: false},
                {text: 'Expert non-independent', value: 'expert_amount', sortable: false},
                {text: 'Expert independent', value: 'expert_independent_amount', sortable: false},
                { text: 'Actions', sortable: false, width: "80px" }
            ],
            fees: [],
            today: moment().format('YYYY-MM-DD')
          }
        },
        computed: {
          current() {
            return this.fees.find(f => f.effective_date <= this.today) //retourne la première et les fees sont triés correctement
          }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('freelances-prices-lists', {sortBy: 'effective_date', descending: true}).then(res => {
                    this.fees = res.data;
                })
            },
            deleteImpl (item) {
                Params.delete('freelances-prices-lists', item.id).then(() => {
                    this.fetch();
                    this.$snotify.success(`The period has been deleted`)
                })
            }
        }
    }
</script>
